export default __webpack_public_path__ + "static/media/Snowmelt_1.b8c32740.webm";